import { Lesson, MultipleChoiceOption } from 'controllers/types';
import { useKyronMutation } from './kyronMutation';

export type GenerateQuestionsPayload = {
  lessonTitle: string;
  lessonObjective: string;
  audience: string;
  signedMaterialIds: string[];
  questionType: string | null;
};

export type QuestionResponse = {
  question: string;
  answer: string;
  explanation: string;
  multiplechoices: MultipleChoiceOption[] | null;
  topic: string;
};

export const useGenerateEntireLesson = () =>
  useKyronMutation<GenerateQuestionsPayload, Lesson>(`/simple_lessons/generate_entire_lesson`, {
    invalidates: ['/lessons'],
  });
